/**
 * Date helpers for the chat day separators and the floating date pill.
 *
 * Labels follow Telegram: today / yesterday collapse to words, anything older
 * shows the full localized date ("21 May 2026"). All comparisons are made
 * against the viewer's local calendar day.
 */

/** Local calendar-day key (`YYYY-MM-DD`) used to group messages by day. */
export function localDayKey(iso: string): string {
  const date = new Date(iso);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Local midnight for [iso] — the instant handed to the "jump to date" request. */
export function startOfLocalDay(iso: string): Date {
  const date = new Date(iso);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

/** Separator/pill label: today / yesterday word, else the full localized date. */
export function daySeparatorLabel(
  iso: string,
  locale: string,
  t: (key: string) => string,
  now: Date = new Date(),
): string {
  const target = startOfLocalDay(iso);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.round((today.getTime() - target.getTime()) / 86_400_000);
  if (diffDays === 0) {
    return t('chats.today');
  }
  if (diffDays === 1) {
    return t('chats.yesterday');
  }
  return target.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
